import React, {Component} from "react";
import {connect} from "react-redux";

import {setSwitchMapControlAction} from "./../../actions/SettingsAction";

import "./SwitchControl.css";

class SwitchControl extends Component {

  constructor(props) {
    super();
    this.onOptionSelected = this.onOptionSelected.bind(this);
  }

  componentDidMount() {
    const {options, selectedItems, optionsKey, setSwitchMapControlAction} = this.props;
    if (!selectedItems[optionsKey]){
      setSwitchMapControlAction(options[0], optionsKey);
    }
  }

  onOptionSelected = (option) => {
    const {optionsKey, selectedItems, setSwitchMapControlAction} = this.props;
    const selectedItem = selectedItems[optionsKey];
    if (selectedItem.key !== option.key){
      setSwitchMapControlAction(option, optionsKey);
    }
  }

  render() {
    const {label, options, optionsKey, selectedItems, disabled} = this.props;
    const selectedItem = selectedItems[optionsKey];
    return (
      <div className="fow-switch-control">
        {disabled &&
          <div className="fow-switch-disabled"></div>
        }
        {label &&
          <span className="fow-switch-label fow-font-text fow-font-size-sm">{label}</span>
        }
        <div className="fow-switch-options">
          {options.map(item =>
            <div key={item.key} className={`fow-switch-options-item fow-font-text fow-font-size-md ${selectedItem && selectedItem.key === item.key ? 'fow-switch-options-item-selected' : ''}`} onClick={() => this.onOptionSelected(item)}>{item.value}</div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedItems: state.settings.switch
  };
};
const mapDispatchToProps = dispatch => ({
  setSwitchMapControlAction: (data, group) => dispatch(setSwitchMapControlAction(data, group))
});


export default connect(mapStateToProps, mapDispatchToProps)(SwitchControl);
